/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, FC, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import {
  Typography,
  TextField,
  IconButton,
  Button,
  Drawer,
} from '@material-ui/core';
import api from '../../services/ApiInstance';
import ApiRoutes from '../../services/ApiRoutes';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import TrackerViewer from './TrackerViewer';
import { TrackerItem } from './TrackerItem';
import { AlertItem } from './AlertItem';
import { useTrackerStyles } from './styles';
import ConfirmDialog from '../dialog/ConfirmDialog';
import { toast } from 'react-toastify';
import { AlertDto, AlertUserDto, TrackerDto } from '../../api/apiDtos';
import { AlertsConfigContext } from '../../context/AlertConfigContextProvider';
import { selectedAlert } from '../../signals/selectedAlert';
import { listOfTrackers } from '../../components/widgets/NotificationTable';
import { listOfAlerts } from '../../components/widgets/NotificationTable';
import { useEffectAsync } from '../../hooks/useEffectAsync';
import { formatDateCommon } from '../../helpers/date-helper';
import AddAlertOutlined from '@material-ui/icons/AddAlertOutlined';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import EditOutlined from '@material-ui/icons/EditOutlined';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import NotificationsOffIcon from '@material-ui/icons/NotificationsOff';
import { Tooltip } from '@material-ui/core';
import { AlertTypes } from '../../constants';
import { Props } from 'recharts/types/container/Surface';
import useLoggedInUser from '../../useLoggedInUser';

const TrackerPage: FC<Props> = ({}) => {
  //setAlertConfig takes 3 parameters - Create, Delete, Edit => will show respective pop up based on selected parameter
  const { callAlerts, setAlertsConfig } = useContext(AlertsConfigContext);
  const { alertId }: any = useParams();
  const classes = useTrackerStyles();
  const { currentUser } = useLoggedInUser();

  const [selectedTrackerIndex, setSelectedTrackerIndex] = useState(null);
  const [selectedAlertIndex, setSelectedAlertIndex] = useState(null);

  //selected alert comes from this selectedAlert.value which is imported from signals
  const [currentTracker, setCurrentTracker] = useState<TrackerDto>(null);

  const [tabValue, setTabValue] = useState<string>('1');
  const [graphData, setGraphData] = useState<TrackerDto | AlertDto>(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const SIDEBAR_WIDTH = 287;

  const handleTabChange = async (
    e: React.ChangeEvent<{}>,
    newValue: string
  ) => {
    setTabValue(newValue);
    if (!listOfTrackers.value?.length) {
      await loadTrackers();
    }
    if (!listOfAlerts.value?.length) {
      await loadAlerts();
    }
    if (newValue === '1') {
      setSelectedTrackerIndex(0);
      setCurrentTracker(listOfTrackers.value[0]);
      setSelectedAlertIndex(null);
      selectedAlert.value = null;
    } else if (newValue === '1' && !listOfTrackers.value?.length) {
      setSelectedTrackerIndex(null);
      setCurrentTracker(null);
      setSelectedAlertIndex(null);
      selectedAlert.value = null;
      return;
    }
    if (newValue === '2' && listOfAlerts.value) {
      setSelectedAlertIndex(0);
      selectedAlert.value = listOfAlerts.value[0];
      setSelectedTrackerIndex(null);
      setCurrentTracker(null);
    } else if (newValue === '2' && !listOfAlerts.value?.length) {
      selectedAlert.value = null;
      setSelectedAlertIndex(null);
      setSelectedTrackerIndex(null);
      setCurrentTracker(null);
    }
  };

  useEffectAsync(async () => {
    if (!listOfAlerts?.value.length) {
      await loadAlerts();
    }
    if (!listOfTrackers?.value.length) {
      await loadTrackers();
    }
    if (alertId) {
      let foundTracker;
      let foundAlert;

      foundAlert = listOfAlerts.value.find((x) => x.id === alertId);
      if (foundAlert) {
        selectedAlert.value = foundAlert;
        const foundAlertIdIndex = listOfAlerts.value?.findIndex(
          (x) => x.id === alertId
        );
        if (foundAlertIdIndex > -1) {
          setSelectedAlertIndex(foundAlertIdIndex);
          setTabValue('2');
          setSelectedTrackerIndex(null);
          setCurrentTracker(null);
          return;
        } else {
          selectedAlert.value = listOfAlerts.value[0];
          setSelectedAlertIndex(0);
          setTabValue('2');
          toast.error('Alert not found');
          return;
        }
      }
      foundTracker = listOfTrackers.value.find((x) => x.id === alertId);
      if (foundTracker) {
        setCurrentTracker(foundTracker);
        const foundTrackerIndex = listOfTrackers.value.findIndex(
          (x) => x.id === alertId
        );
        if (foundTrackerIndex > -1) {
          setSelectedTrackerIndex(foundTrackerIndex);
          setTabValue('1');
          setSelectedAlertIndex(null);
          selectedAlert.value = null;
          return;
        } else {
          setCurrentTracker(listOfTrackers.value[0]);
          setSelectedTrackerIndex(0);
          setTabValue('1');
          toast.error('Tracker not found');
          return;
        }
      }
    }
    if (listOfTrackers.value.length) {
      setCurrentTracker(listOfTrackers.value[0]);
      setSelectedTrackerIndex(0);
      setTabValue('1');
      return;
    }
    if (listOfAlerts.value.length) {
      selectedAlert.value = listOfAlerts.value[0];
      setSelectedAlertIndex(0);
      setTabValue('2');
      return;
    } else {
      setTabValue('1');
      selectedAlert.value = null;
      setCurrentTracker(null);
      listOfAlerts.value = null;
      listOfTrackers.value = null;
    }
  }, []);

  useEffectAsync(async () => {
    if (callAlerts) {
      await loadAlerts();
    }
  }, [callAlerts]);

  async function loadAlerts() {
    await api
      .get<unknown, AlertDto[]>(ApiRoutes.getAlerts)
      .then((_listOfAlerts) => {
        if (_listOfAlerts?.length) {
          listOfAlerts.value = _listOfAlerts;
          selectedAlert.value = listOfAlerts.value[0];
          setSelectedAlertIndex(0);
        } else {
          listOfAlerts.value = null;
          selectedAlert.value = null;
        }
      });
  }

  async function loadTrackers() {
    await api
      .get<unknown, TrackerDto[]>(ApiRoutes.getTrackers)
      .then((_listOfTrackers) => {
        if (_listOfTrackers?.length) {
          listOfTrackers.value = _listOfTrackers;
        }
      });
  }

  useEffect(() => {
    if (selectedAlert.value !== null) {
      setGraphData(selectedAlert.value);
    } else if (currentTracker !== null) {
      setGraphData(currentTracker);
    } else setGraphData(null);
  }, [selectedAlert.value, currentTracker]);
  useEffect(() => {
    console.log(graphData);
  }, [graphData]);

  const handleCheckedAlertClick = (event, alertIndex, item: AlertDto) => {
    api
      .put<string, AlertUserDto>(`${ApiRoutes.alertToggle}/${item.id}`, item.id)
      .then((res: AlertUserDto) => {
        if (!res.muted) {
          toast.success('Notification Turned On');
        } else {
          toast.success('Notification Turned Off');
        }
        loadAlerts();
      });
  };

  const deleteTrackerConfirmation = (event, item) => {
    setSelectedTrackerIndex(
      listOfTrackers.value?.findIndex((x) => x.id === item.id)
    );
    setCurrentTracker(item);
    setDeleteDialogOpen(true);
  };

  const editTrackerConfirmation = (event, item) => {
    setSelectedTrackerIndex(
      listOfTrackers.value?.findIndex((x) => x.id === item.id)
    );
    setCurrentTracker(item);
    setEditDialogOpen(true);
  };

  const editTracker = () => {
    setEditDialogOpen(false);
    const tracker: TrackerDto = {
      //only thing getting updated here
      name: currentTracker.name,
      //these can delete the rest but it allows for expansion if necessary
      id: currentTracker?.id,
      actions: currentTracker?.actions,
      dateCreated: currentTracker?.dateCreated,
      dateUpdated: currentTracker?.dateUpdated,
      endDate: currentTracker?.endDate,
      filters: currentTracker?.filters,
      hasAlert: currentTracker?.hasAlert,
      startDate: currentTracker?.startDate,
      targets: currentTracker?.targets,
    };
    api.post<TrackerDto, TrackerDto>(ApiRoutes.updateTracker, tracker).then(
      (response) => {
        if (response) {
          toast.success('Tracker updated');
        }
        setCurrentTracker(response);
        loadTrackers();
      },
      (err) => {
        toast.error('Tracker could not be updated');
      }
    );
  };

  const deleteTracker = () => {
    setDeleteDialogOpen(false);
    api
      .post<TrackerDto, TrackerDto>(ApiRoutes.deleteTracker, currentTracker)
      .then(
        (response) => {
          if (response) {
            const selectedTrackerIndex = listOfTrackers.value?.findIndex(
              (x) => x.id === currentTracker.id
            );
            const items = [...listOfTrackers.value];
            items.splice(selectedTrackerIndex, 1);
            listOfTrackers.value = items;
            setSelectedTrackerIndex(0);
            setCurrentTracker(listOfTrackers.value[0]);
            toast.success('Tracker deleted successfully');
          }
          loadTrackers();
        },
        (err) => {
          toast.error('Tracker could not be deleted');
        }
      );
  };

  async function handleCheckedTrackerNotificationClick(
    event,
    alertIndex,
    item: TrackerDto
  ) {
    const tracker: TrackerDto = {
      //only thing getting updated here
      hasAlert: item.hasAlert === true ? false : true,
      //these can delete the rest but it allows for expansion if necessary
      id: item?.id,
      actions: item.actions,
      dateCreated: item.dateCreated,
      dateUpdated: item.dateUpdated,
      endDate: item.endDate,
      filters: item.filters,
      name: item.name,
      startDate: item.startDate,
      targets: item.targets,
    };
    await api
      .post<TrackerDto, TrackerDto>(ApiRoutes.updateTracker, tracker)
      .then(
        (response) => {
          if (response.hasAlert) {
            toast.success('Notification Turned On');
            setCurrentTracker(response);
          } else {
            toast.success('Notification Turned Off');
          }
          loadTrackers();
        },
        (err) => {
          toast.error('Could not update notification');
        }
      );
  }

  const handleAlertItemSelected = (alert: AlertDto) => {
    selectedAlert.value = alert;
    setSelectedAlertIndex(
      listOfAlerts.value?.findIndex((x) => x.id === alert.id)
    );
  };

  function CreateAlert() {
    setAlertsConfig(AlertTypes.create);
  }

  return (
    <>
      <div className={classes.drawerContainer}>
        <Drawer
          classes={{ paper: classes.drawerPaper }}
          variant="persistent"
          anchor="left"
          open={sidebarOpen}
        >
          {/* Trackers Section */}
          <div className={classes.sidebarSectionHeader}>
            <Typography className={classes.sidebarSectionTitle}>Trackers</Typography>
          </div>
          <div className={classes.sidebarSection} style={{ maxHeight: '45vh' }}>
            {listOfTrackers.value?.length ? (
              <List style={{ padding: 0 }}>
                {listOfTrackers.value.map((item, index) => {
                  const isActive = selectedTrackerIndex === index && !selectedAlert.value;
                  return (
                    <ListItem
                      key={`tracker-${index}`}
                      className={`${classes.sidebarItem} ${isActive ? classes.sidebarItemActive : ''}`}
                      onClick={() => {
                        setCurrentTracker(item);
                        setSelectedTrackerIndex(index);
                        setSelectedAlertIndex(null);
                        selectedAlert.value = null;
                        setTabValue('1');
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <ListItemText
                        primary={<Typography className={classes.sidebarItemTitle}>{item.name}</Typography>}
                        secondary={
                          <div className={classes.sidebarItemDate}>
                            {formatDateCommon(item.dateCreated)}
                          </div>
                        }
                      />
                      <div className={classes.sidebarActions}>
                        <ChevronRightIcon style={{ fontSize: 18, color: 'rgba(255,255,255,0.3)' }} />
                        <Tooltip title={item.hasAlert ? 'Mute Notification' : 'Unmute Notification'}>
                          <IconButton
                            size="small"
                            className={classes.sidebarActionBtn}
                            onClick={(e) => { e.stopPropagation(); handleCheckedTrackerNotificationClick(e, index, item); }}
                          >
                            {item.hasAlert ? <NotificationsNoneIcon style={{ fontSize: 14 }} /> : <NotificationsOffIcon style={{ fontSize: 14 }} />}
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Edit Tracker">
                          <IconButton
                            size="small"
                            className={classes.sidebarActionBtn}
                            onClick={(e) => { e.stopPropagation(); editTrackerConfirmation(e, item); }}
                          >
                            <EditOutlined style={{ fontSize: 14 }} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete Tracker">
                          <IconButton
                            size="small"
                            className={classes.sidebarActionBtn}
                            onClick={(e) => { e.stopPropagation(); deleteTrackerConfirmation(e, item); }}
                          >
                            <DeleteOutline style={{ fontSize: 14 }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </ListItem>
                  );
                })}
              </List>
            ) : (
              <div className={classes.sidebarNoItems}>No trackers found</div>
            )}
          </div>

          {/* Alerts Section */}
          <div className={classes.sidebarSectionHeader} style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>
            <Typography className={classes.sidebarSectionTitle}>Alerts</Typography>
            <Button
              className={classes.addButton}
              size="small"
              onClick={CreateAlert}
              startIcon={<AddAlertOutlined style={{ fontSize: 16 }} />}
            >
              Add
            </Button>
          </div>
          <div className={classes.sidebarSection} style={{ maxHeight: '45vh' }}>
            {listOfAlerts.value?.length ? (
              <List style={{ padding: 0 }}>
                {listOfAlerts.value.map((item, index) => {
                  const isActive = selectedAlertIndex === index && !!selectedAlert.value;
                  return (
                    <ListItem
                      key={`alert-${index}`}
                      className={`${classes.sidebarItem} ${isActive ? classes.sidebarItemActive : ''}`}
                      onClick={() => {
                        selectedAlert.value = item;
                        setSelectedAlertIndex(index);
                        setSelectedTrackerIndex(null);
                        setCurrentTracker(null);
                        setTabValue('2');
                        api.get(`${ApiRoutes.interactWithAlert}/${item.id}`);
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <ListItemText
                        primary={
                          <Typography className={classes.sidebarItemTitle}>
                            {item.level2Classification?.label ?? item.subClassification?.label ?? 'Alert'}
                          </Typography>
                        }
                        secondary={
                          <div className={classes.sidebarItemDate}>
                            {formatDateCommon(item.createdDate)}
                          </div>
                        }
                      />
                      <div className={classes.sidebarActions}>
                        <ChevronRightIcon style={{ fontSize: 18, color: 'rgba(255,255,255,0.3)' }} />
                        {(() => {
                          const alertUser = item.alertUsers?.find((x) => x.userId === currentUser?.id);
                          const isMuted = !alertUser || alertUser.muted;
                          return (
                            <Tooltip title={isMuted ? 'Unmute Notification' : 'Mute Notification'}>
                              <IconButton
                                size="small"
                                className={classes.sidebarActionBtn}
                                onClick={(e) => { e.stopPropagation(); handleCheckedAlertClick(e, index, item); }}
                              >
                                {isMuted
                                  ? <NotificationsOffIcon style={{ fontSize: 14 }} />
                                  : <NotificationsNoneIcon style={{ fontSize: 14 }} />}
                              </IconButton>
                            </Tooltip>
                          );
                        })()}
                        <Tooltip title="Edit Alert">
                          <IconButton
                            size="small"
                            className={classes.sidebarActionBtn}
                            onClick={(e) => {
                              e.stopPropagation();
                              selectedAlert.value = item;
                              handleAlertItemSelected(item);
                              setAlertsConfig(AlertTypes.edit);
                            }}
                          >
                            <EditOutlined style={{ fontSize: 14 }} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete Alert">
                          <IconButton
                            size="small"
                            className={classes.sidebarActionBtn}
                            onClick={(e) => {
                              e.stopPropagation();
                              selectedAlert.value = item;
                              handleAlertItemSelected(item);
                              setAlertsConfig(AlertTypes.delete);
                            }}
                          >
                            <DeleteOutline style={{ fontSize: 14 }} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </ListItem>
                  );
                })}
              </List>
            ) : (
              <div className={classes.sidebarNoItems}>No alerts found</div>
            )}
          </div>
        </Drawer>

        <IconButton
          color="primary"
          size="small"
          className={sidebarOpen ? classes.toggleButton : classes.toggleButtonCollapsed}
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          {sidebarOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
      </div>

      {/* Main Content */}
      <div className={classes.mainContentArea} style={{ marginLeft: sidebarOpen ? `${SIDEBAR_WIDTH}px` : 0 }}>
        {graphData ? (
          <TrackerViewer
            tabValue={tabValue}
            item={graphData}
            disabled={true}
          />
        ) : null}
      </div>

      <ConfirmDialog
        open={deleteDialogOpen}
        onCancel={() => setDeleteDialogOpen(false)}
        onConfirm={deleteTracker}
        title="Delete Tracker"
        confirm="Delete"
      >
        <Typography variant="body1">
          Tracker: {''}
          <strong style={{ fontWeight: 'bold' }}>
            {currentTracker && currentTracker.name}
          </strong>
          {''} will be deleted.
          <br />
          Do you wish to continue?
        </Typography>
      </ConfirmDialog>
      <ConfirmDialog
        open={editDialogOpen}
        onCancel={() => setEditDialogOpen(false)}
        onConfirm={editTracker}
        title={`Edit Tracker Name: ${currentTracker?.name}`}
        confirm="Save"
      ></ConfirmDialog>
    </>
  );
};

export default TrackerPage;
